module.exports = __webpack_public_path__ + "img/logo_k12.f93147ea.png";